import { inject, Injectable, signal } from "@angular/core";
import { Notifications } from "../models/notification";
import { environment } from "../../../environments/environment";
import { OneSignal } from "onesignal-ngx";

@Injectable({ providedIn: 'root' })
export class NotificationDataService{    
    
    private oneSignal = inject(OneSignal);
    public notifications= signal<Notifications[]>([]);


    constructor(){ 
       
    }

    setNotifications(notifications: Notifications[]){
        this.notifications.set(notifications)     
    }
    
    addNotification(notification: Notifications){
        this.notifications.update(current => [...current, notification]);
    }

    removeNotification(notificaion: Notifications){
       this.notifications.update(current => 
        current.filter(n => n.notificationId !== notificaion.notificationId)
        );
    }
}